import * as querystring from "querystring";
const REQUEST_URL = 'https://api.zware.space';
// const REQUEST_URL = 'http://localhost:9965';
class API {

    setAccessToken(token) {
        this.token = token;
    }

    async execute(apiMethod, params = {}, method='GET') {
        return new Promise((resolve, reject) => {
            let config = {
                method: method,
            };
            if (localStorage.accessToken) {
                params.accessToken = localStorage.accessToken;
            }

            let url = REQUEST_URL + '/method/' + apiMethod;

            if (method === 'POST') {
                config.body = JSON.stringify(params)
            } else {
                url += '?' + querystring.stringify(params);
            }

            fetch(url, config).then(data => {
                data.text().then((text) => {
                    const JsonData = JSON.parse(text);
                    if(JsonData.response){
                        resolve(JsonData);
                    }else if(JsonData.error){
                        reject(JsonData);
                    }else{
                        resolve(JsonData);
                    }

                });
            });

        })
    }
}

export default new API();
